module.exports = __webpack_public_path__ + "static/media/Layout28.fbc4ca50.png";